import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { RouterProvider } from 'react-router-dom';
import Router from './App';
import store from './Store'
import './vercel.json'
import { Provider } from 'react-redux';
import { initializeMetaPixel, initializeGA4 } from './config/analytics';
// import 'bootstrap/dist/css/bootstrap.css';

// Initialize analytics on app startup
if (typeof window !== 'undefined') {
  initializeMetaPixel();
  initializeGA4();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={Router}>
      </RouterProvider>
    </Provider>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
